import * as Yup from 'yup'
import {TabOption} from '../../../../shared/components/FormTabHeader'

export interface ILookupItem {
  id: string
  name: string
}

export type VehicleGroupFilter = 'PARK_GROUPS' | 'ALL' | 'ACTIVE_GROUPS' | 'SEGMENT_GROUPS' | 'WITH_PRICE_GROUPS'

export const VEHICLE_GROUP_FILTER_OPTIONS: {value: VehicleGroupFilter; label: string}[] = [
  {value: 'WITH_PRICE_GROUPS', label: 'Sadece Fiyatı Olanlar'},
  {value: 'PARK_GROUPS', label: 'Sadece Parkta olanlar'},
  {value: 'ALL', label: 'Hepsi'},
  {value: 'ACTIVE_GROUPS', label: 'Aktif Gruplar'}, 
]

export const SEGMENT_FILTER_OPTIONS: {value: VehicleGroupFilter; label: string}[] = [
  {value: 'WITH_PRICE_GROUPS', label: 'Sadece Fiyatı Olanlar'}, 
  {value: 'SEGMENT_GROUPS', label: 'Segment Gruplar'},
]

export type SortKey = 'name' | 'sipp' | 'segment'

export const SORT_OPTIONS: {value: SortKey; label: string}[] = [
  {value: 'name', label: 'İsim'},
  {value: 'sipp', label: 'SIPP'},
  {value: 'segment', label: 'Segment'},
]

export interface IXmlTariffPriceRow {
  vehicleGroupId: string
  vehicleGroupName: string 
  segmentId: string
  segmentName: string 
  dayOnePrice: number
  dayTwoPrice: number
  dayThreePrice: number
  dayFourPrice: number
  dayFivePrice: number
  daySixPrice: number
  daySevenPrice: number 
  monthlyPrice: number
  currencyId: string
}

export interface IXmlTariffDetailModel {
  id: string
  name: string
  code: string
  type: string
  status: string
  approvalStatus: string
  reservationSource: string
  branch: string
  location: string
  startDate: string
  endDate: string
}

export const initialValuesXmlTariffDetail: IXmlTariffDetailModel = {
  id: '',
  name: '',
  code: '',
  type: '',
  status: '',
  approvalStatus: '',
  reservationSource: '',
  branch: '',
  location: '',
  startDate: '',
  endDate: '',
}

export const tabOptionsXmlTariffDetail: TabOption[] = [
  {key: 'form', title: 'Xml Tarife Fiyat Girişleri', icon: 'bi bi-plus-lg'},
  {key: 'list', title: 'Xml Fiyat Aktarımı', icon: 'bi bi-layers'},
]

export const validationXmlTariffDetail = Yup.object().shape({})
